// extracted by mini-css-extract-plugin
module.exports = {"playArea":"PlayArea_playArea__2YFR8","resourceBox":"PlayArea_resourceBox__3fGwH","requirementBox":"PlayArea_requirementBox__3Yo_m","item":"PlayArea_item__auzrz"};